function loadScripts(e) {
  if(e && !e.isTrusted){
    return;
  }


  // alert('hii')
    setTimeout(function () {
    // loadCSS('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.css');
    loadScript("//www.wearcomet.com/cdn/shop/t/253/assets/hp-custom-script.js?v=138988952366681973331786110206");
    loadScript("//www.wearcomet.com/cdn/shop/t/253/assets/details-disclosure.js?v=153497636716254413831783066235");
    // loadScript("//www.wearcomet.com/cdn/shop/t/253/assets/details-modal.js?v=78776693196219774011790830020");
    loadScript("//www.wearcomet.com/cdn/shop/t/253/assets/cart-notification.js?v=160453272920806432391783066235");
    loadScript("//www.wearcomet.com/cdn/shop/t/253/assets/cart-drawer-script.js?v=24308693613533450291783066233");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-slider.css?v=111384418465749404671783066236");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/customer.css?v=63738949733641882881783066234");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/popup.css?v=184015748029876475071790757279");    
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-cart-drawer.css?v=15566466097704326981783066232");
    // loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/new-testimonial-carousel.css?v=89025444566313207841783066488"); // loaded eagerly in homepage-render-js-asset
    // loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/custom-mega-menu.css?v=51245767550190522631790757271"); // loaded eagerly in homepage-render-js-asset
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/section-footer.css?v=171161867995400310821783066233");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-newsletter.css?v=103472482056003053551783066235");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-list-menu.css?v=151968516119678728991783066234");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-list-payment.css?v=69253961410771838501783066235");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-list-social.css?v=52211663153726659061783066236");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/footer.css?v=87833187280690901731783066488");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-predictive-search.css?v=85913294783299393391783066233");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-search.css?v=184225813856820874251783066235");
    // loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-menu-drawer.css?v=79640312649104846631790834824");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-cart-notification.css?v=108833082844665799571783066233");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-cart-items.css?v=138827669520066067571787979383");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-price.css?v=130611431301202989081788927035");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-loading-overlay.css?v=167310470843593579841783066236");

    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-cart.css?v=61086454150987525971783066234");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-totals.css?v=86168756436424464851783066233");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-discounts.css?v=164788277903287711551787990254");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-loading-overlay.css?v=167310470843593579841783066236");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/lazy-video-styles.css?v=107481450961078042501783066233");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-localization-form.css?v=173603692892863148811783066232");

    window.countrySelectorLoaded = false;
    if (window.countrySelector && !window.countrySelectorLoaded) {
      var script = document.createElement('script');
      script.src = "//www.wearcomet.com/cdn/shop/t/253/assets/localization-form.js?v=131562513936691783521783066234";
      script.defer = true;
      document.body.appendChild(script);
      window.countrySelectorLoaded = false;
    }

    document.querySelectorAll('.placeholder-slk-prnt').forEach(el => {
      el.style.opacity = '0';
    });

    document.querySelectorAll('.onrendered-slider-prnt').forEach(el => {
      el.style.opacity = '1';
    });

    
  // loadScript("//www.wearcomet.com/cdn/shop/t/253/assets/global.js?v=164393985785615671021790834824");
  loadScript("//www.wearcomet.com/cdn/shop/t/253/assets/quick-add-to-cart.js?v=149215956464844627301786110209");


    
  }, 10);


  // Remove event listeners after scripts are loaded
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mousemove', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

// Check if the user is beyond 400px from the top
if (window.scrollY >= 400 || window.__openCartDrawer) {
  loadScripts();
} else {
  document.addEventListener('mousemove', loadScripts);
  document.addEventListener('click', loadScripts);
  document.addEventListener('scroll', loadScripts);
}

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}